import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["imoButton", "customButton"]
    static values = { selected: String }

    connect() {
        const tab = this.getTabFromQueryString()
        if (tab === 'eexi-custom-tab') {
            this.toggleSections(".eexi-section-result-imo-std", false)
            this.toggleSections(".eexi-section-result-custom", true)
        } else {
            this.toggleSections(".eexi-section-result-imo-std", true)
            this.toggleSections(".eexi-section-result-custom", false)
        }
    }

    selectTab(event) {
        const selected = event.currentTarget
        this.toggleTab(selected)
    }

    toggleTab(selected) {
        const tab = selected.getAttribute("tab")
        this.selectedValue = tab
        const isCustom = tab === "eexi-custom-tab"

        // Button state
        this.imoButtonTarget.classList.remove("selected")
        this.customButtonTarget.classList.remove("selected")
        selected.classList.add("selected")

        // Results visibility
        this.toggleSections(".eexi-section-result-imo-std", !isCustom)
        this.toggleSections(".eexi-section-result-custom", isCustom)

        // Labels visibility
        this.toggleSections(".eexi-section-imo-std-labels", !isCustom)
        this.toggleSections(".eexi-section-custom-labels", isCustom)

        // Update hrefs
        this.updateQueryParams(tab)
    }

    toggleEvent(event) {
        if (this.selectedValue === this.imoButtonTarget.getAttribute("tab")) {
            this.toggleTab(this.imoButtonTarget)
        }
        if (this.selectedValue === this.customButtonTarget.getAttribute("tab")) {
            this.toggleTab(this.customButtonTarget)
        }
    }

    toggleSections(selector, show) {
        document.querySelectorAll(selector).forEach(el => {
            el.style.display = show ? "block" : "none"
        })
    }

    updateQueryParams(tab) {
        const updateHref = (el) => {
            const href = el.getAttribute("href")
            const url = new URL("https://example.com" + href) // dummy domain
            url.searchParams.set("eexi_tab", tab)
            el.setAttribute("href", url.pathname + url.search)
        }

        document.querySelectorAll(".market-rate-body .selection-button:not(.selected) a, .calculator-links .navbar-link")
            .forEach(updateHref)
    }

    getTabFromQueryString() {
        const params = new URLSearchParams(window.location.search)
        return params.get("eexi_tab")
    }
}
